import React from 'react';
import I18n from 'i18n-js';

import { Filter } from './search_filters';
import DismissibleFilterGroup from './dismissible_filter_group';
import CoreLink from './core_link';
import { Paths } from '../url_helpers';
import { Location } from 'history';
import qs from 'qs';

interface IProps {
  filters?: Filter[];
  location: Location;
}

export default function MarketplaceDismissibleFilterRow({
  filters = [],
  location = null,
}: IProps) {
  const pathname = location.pathname;
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const clearFilterUrl = pathname?.includes('/marketplace') ?
    Paths.marketplace.expand({ query: query?.query }) : pathname;

  return (
    <>
      {filters.map(filter => {
        return (
          <DismissibleFilterGroup
            filter={filter}
            location={location}
          />
        );
      })}

      {filters.length > 1 &&
        <CoreLink
          to={clearFilterUrl}
          className="filter-chip filter-chip--text-link"
        >
          {I18n.t('commons.marketplaceFilters.clearFilters')}
        </CoreLink>
      }
    </>
  );
}
